/**
 * Line icons for the collection / build entry tiles.
 *
 * These replace the decorative geometric-shape entities the tiles used to
 * render (U+25A3 WHITE SQUARE CONTAINING BLACK SMALL SQUARE for collection,
 * U+2727 for suggest, U+25C6 for analyze). The square one was the reason:
 * next to the word "collection" it read as an unchecked checkbox, and on
 * /build it sat in the same row as an ACTUAL checkbox. A shape that offers
 * an affordance it does not have is worse than no icon at all.
 *
 * Stroke-based on a 24 viewBox, sized and coloured by the caller through
 * `className` (currentColor throughout), matching the MobileNav icon idiom.
 */

type IconProps = { className?: string }

/** Two fanned Magic cards. The back card is stroke-only and the front carries
 *  a faint wash plus a title bar, so the pair still reads as two cards rather
 *  than one thick rectangle at 24px. */
export function CardStackIcon({ className = 'w-6 h-6' }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <rect
        x="3.6"
        y="5.4"
        width="9.8"
        height="13.8"
        rx="1.6"
        transform="rotate(-14 8.5 12.3)"
        stroke="currentColor"
        strokeWidth="1.5"
        opacity="0.5"
      />
      <rect
        x="10.2"
        y="4.6"
        width="10.2"
        height="14.8"
        rx="1.7"
        fill="currentColor"
        fillOpacity="0.12"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.6 8.4h5.4"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        opacity="0.75"
      />
    </svg>
  )
}


/** Four-point sparkle for the "suggest a commander" tile. */
export function SuggestIcon({ className = 'w-6 h-6' }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M13 3.4c0 3.9 2.6 6.5 6.5 6.5-3.9 0-6.5 2.6-6.5 6.5 0-3.9-2.6-6.5-6.5-6.5 3.9 0 6.5-2.6 6.5-6.5z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="currentColor"
        fillOpacity="0.12"
      />
      <path
        d="M6.6 15.4c0 1.9-1.2 3.2-3.1 3.2 1.9 0 3.1 1.3 3.1 3.2 0-1.9 1.2-3.2 3.1-3.2-1.9 0-3.1-1.3-3.1-3.2z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
        opacity="0.65"
      />
    </svg>
  )
}
